export class Search {

  constructor(container, type) {
    this._container = container;
    this._elem = this._container.querySelector('.control__input--search');
    this._reset = this._container.querySelector('.control__reset');
    this._callback = null;
    this._type = type;

    this._stringsContainer = this._type === 'subs' ? '.sub-filter__name' : '.control__label span';
    this._blockContainer = this._type === 'subs' ? '.sub-filter__item' : '.block-filter__item';

    this._elemInputHandler = this._elemInputHandler.bind(this);
    this._resetClickHandler = this._resetClickHandler.bind(this);

    this._elem.addEventListener('input', this._elemInputHandler);
    this._reset.addEventListener('click', this._resetClickHandler);
  }

  setClickHandler(callback) {
    this._callback = callback;
  }


  search(list) {
    const regexp = new RegExp(this._elem.value, 'ig');
    const strings = list.querySelectorAll(this._stringsContainer);

    strings.forEach((str) => {
      const text = str.textContent;
      const parent = str.closest(this._blockContainer);
      return text.match(regexp) ? parent.classList.remove('hide') : parent.classList.add('hide');
    });
  }

  clear() {
    if (this._elem) {
      this._elem.value = '';
    }
  }

  _elemInputHandler() {
    if (this._elem.value === '') {
      this._container.classList.remove('active');
    } else {
      this._container.classList.add('active');
    }
  }

  _resetClickHandler(evt) {
    evt.preventDefault();
    this._container.classList.remove('active');
    this._callback();
  }
}
